function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.8309,
  cy: 18.4917,
  r: 15,
  transform: "rotate(-12.199 17.8309 18.4917)",
  fill: "#403D3A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1986 17.1434L18.5 13.842L21.8031 17.1451L23.7241 15.2241L18.5 10L13.2776 15.2224L15.1986 17.1434ZM10 18.5L11.921 16.579L13.842 18.5L11.921 20.421L10 18.5ZM15.1986 19.8566L18.5 23.158L21.8031 19.8549L23.7241 21.7751L18.5 27L13.2776 21.7776L13.275 21.7751L15.1986 19.8566ZM23.158 18.5L25.079 16.579L27 18.5L25.079 20.421L23.158 18.5ZM20.4482 18.4983L20.4499 18.4983L20.4499 18.5L18.5 20.4499L16.5526 18.5034L16.5493 18.5L16.5526 18.4974L16.8935 18.1558L17.0593 17.99L18.5 16.5501L20.449 18.4992L20.4482 18.4983Z",
  fill: "#F3BA2F"
});

var SvgBit2 = function SvgBit2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBit2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bit2.27e5d70b.svg";
export { ForwardRef as ReactComponent };